import React from 'react';
import { useNavigate } from 'react-router-dom';
import '@/css/chess-result-modal.css';

type ResultModalProps = {
  isOpen: boolean;
  title: string;
  metaText?: string;
  subtitle?: string;
  details?: string[];
  primaryLabel: string;
  onPrimary: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
  onClose?: () => void;
  allowBackdropClose?: boolean;
  showHomeLink?: boolean;
};

function ResultModal({
  isOpen,
  title,
  metaText,
  subtitle,
  details = [],
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  onClose,
  allowBackdropClose = true,
  showHomeLink = false,
}: ResultModalProps) {
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="chess-result-modal__overlay"
      onClick={() => {
        if (allowBackdropClose) (onClose ?? onPrimary)();
      }}
      role="presentation"
    >
      <div
        className="chess-result-modal__panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button
          type="button"
          aria-label="Close modal"
          className="chess-result-modal__close"
          onClick={() => (onClose ?? onPrimary)()}
        >
          ×
        </button>
        <div className="chess-result-modal__eyebrow">Match Result</div>
        <h2 className="chess-result-modal__title">{title}</h2>
        {metaText ? <p className="chess-result-modal__meta">{metaText}</p> : null}
        {subtitle ? <p className="chess-result-modal__subtitle">{subtitle}</p> : null}

        {details.length > 0 ? (
          <ul className="chess-result-modal__details">
            {details.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        ) : null}

        <div className="chess-result-modal__actions">
          {secondaryLabel && onSecondary ? (
            <button
              type="button"
              className="chess-result-modal__button chess-result-modal__button--secondary"
              onClick={onSecondary}
            >
              {secondaryLabel}
            </button>
          ) : null}
        </div>

        {showHomeLink && (
          <button
            type="button"
            aria-label="Go to chess home"
            className="chess-result-modal__home-link"
            onClick={() => navigate('/chess')}
          >
            Back To Chess Home
          </button>
        )}
      </div>
    </div>
  );
}

export default ResultModal;
